import dayjs from 'dayjs';

import { IStages } from 'components/BusinessToolForm/Sections/ImplementationPlan/utils/form';

import { getSortedFilteredGanttChartDataWithDuration } from './getSortedFilteredGanttChartDataWithDuration';
import { GANTT_CHART_STATUSES, IChartStages } from '../types';

export const getGanttChardData = (data: IStages[]) => {
  const chartData: IChartStages[] = data.map((item) => ({
    ...item,
    status: item.status.value,
    from: dayjs(item.from),
    to: dayjs(item.to),
    duration: 0,
    differenceWithStartDate: 0,
  }));

  const { startDate, finishDate } = chartData.reduce(
    (acc, curVal) => {
      if (curVal.from.isValid() && curVal.to.isValid()) {
        acc.startDate = curVal.from.isBefore(acc.startDate) ? curVal.from : acc.startDate;
        acc.finishDate = curVal.to.isAfter(acc.finishDate) ? curVal.to : acc.finishDate;
      }
      return acc;
    },

    { startDate: dayjs(), finishDate: dayjs() },
  );

  const doneChartData = getSortedFilteredGanttChartDataWithDuration({
    chartData,
    filter: GANTT_CHART_STATUSES.DONE,
    startDate,
  });
  const inProgressChartData = getSortedFilteredGanttChartDataWithDuration({
    chartData,
    filter: GANTT_CHART_STATUSES.IN_PROGRESS,
    startDate,
  });
  const toDoChartData = getSortedFilteredGanttChartDataWithDuration({
    chartData,
    filter: GANTT_CHART_STATUSES.TO_DO,
    startDate,
  });

  return { doneChartData, inProgressChartData, toDoChartData, startDate, finishDate };
};
